const useViewModel = (props) => props;

export { useViewModel };
